import { render, staticRenderFns } from "./TypeControlDetailBtn.vue?vue&type=template&id=9f5a3a2a"
import script from "./TypeControlDetailBtn.vue?vue&type=script&lang=js"
export * from "./TypeControlDetailBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports